<template>
  <v-dialog v-model="bModelExportar" persistent max-width="800px">
    <v-card min-height="400px">
      <v-toolbar color="headformsdark" height="45" elevation="0" dense dark>
        <v-spacer />
        <span class="mdlHeadForms">{{ oEquivalencias.msgRangoFechas }}</span>
        <v-spacer />
        <v-btn
          color="btncolor-dark"
          @click="$emit('click', false)"
          icon
          small
          dark
          outlined
        >
          <v-icon size="14px">fa fa-times</v-icon>
        </v-btn>
      </v-toolbar>
      <v-container fluid class="py-3">
        <v-row class="no-gutters text-center justify-center">
          <v-col cols="12" sm="6" class="pa-1">
            <h2 class="text-semibold text-primary-dark ma-0 pa-0 text-center text-uppercase">
              {{ oEquivalencias.cmpFechaInicio }}
            </h2>
            <v-date-picker
              :style="{ width: '100%' }"
              v-model="sFechaRangoInicio"
              scrollable
              locale="es-419"
              color="primarydark"
            />
          </v-col>
          <!-- <v-divider vertical v-if="!$vuetify.breakpoint.xs" />
          <v-divider v-else/> -->

          <v-col cols="12" sm="6" class="pa-1">
            <h2 class="text-semibold text-primary-dark ma-0 pa-0 text-center text-uppercase">
              {{ oEquivalencias.cmpFechaFin }}
            </h2>
            <v-date-picker
              :style="{ width: '100%' }"
              :disabled="bFinInactivo"
              v-model="sFechaRangoFin"
              :min="sFechaRangoInicio"
              :max="sMaxFechaFin"
              scrollable
              locale="es-419"
              color="primarydark"
            />
          </v-col>
        </v-row>
        <v-divider />
        <v-row class="no-gutters mt-2">
          <v-col cols="12" class="text-center">
            <div class="text-medium">
              {{ oEquivalencias.ttlRagoFechas }}
            </div>
            <span class="font-size-1 text-primary">
              {{ sRangoTexto }}
            </span>
          </v-col>
          <v-col cols="12" class="mt-1">
            <div style="width: 100%" class="text-center under-sec-nomargin">
              <v-btn
                class="btn-rounded mx-2"
                depressed
                light
                outlined
                color="btncolor"
                @click="$emit('click', false)"
                >{{ oEquivalencias.btnCancelar }}</v-btn
              >
              <v-btn
                class="btn-rounded mx-2"
                depressed
                light
                dark
                color="btncolor"
                :class="{ 'no-click': bFinInactivo }"
                @click="onExportarRango"
                >{{ oEquivalencias.btnExportar }}</v-btn
              >
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>
 
 <script>
export default {
  name: "DialogoFechaRangoExportar",
  model: {
    prop: "bModelExportar",
    event: "click",
  },
  props: {
    bModelExportar: Boolean,
  },
  data() {
    return {
      bFinInactivo: true,
      sAnoMaximoInicial: null,
      sMaxFechaFin: null,
      aRangoExportar: null,
      sFechaRango: [this.sFechaRangoInicio, this.sFechaRangoFin],
      sFechaRangoInicio:
        this.value == "" || this.value == null
          ? new Date().toISOString().substr(0, 10)
          : this.value,
      sFechaRangoFin:
        this.value == "" || this.value == null
          ? new Date().toISOString().substr(0, 10)
          : this.value,
      oEquivalencias: this.$store.state.jsIdioma.oEquivalencias,
    };
  },
  mounted() {
    let oHoy = new Date();
    let sFecha = new Date(
      oHoy.getFullYear(),
      oHoy.getMonth() + 7,
      oHoy.getDate()
    );
    this.sAnoMaximoInicial = sFecha.toISOString().slice(0, 10);
    this.sMaxFechaFin = this.sAnoMaximoInicial;
  },
  methods: {
    onExportarRango() {
      this.aRangoExportar = [this.sFechaRangoInicio, this.sFechaRangoFin];
      this.$emit("onExportarRango", this.aRangoExportar);
      this.$emit("click", false);
    },
  },
  watch: {
    sFechaRangoInicio() {
      this.bFinInactivo = false;
      let sTempFecha = this.sFechaRangoInicio;
      let sFechaString = sTempFecha.split("-");
      let sFechaInicioActual = new Date(sTempFecha);
      let sFechaFinal = new Date(
        sFechaInicioActual.getFullYear(),
        sFechaInicioActual.getMonth() + 7,
        parseInt(sFechaString[2])
      );
      this.sFechaRangoFin = sTempFecha;
      this.sMaxFechaFin = sFechaFinal.toISOString().slice(0, 10);
    },
  },
  computed: {
    sRangoTexto() {
      return this.sFechaRango.join(
        "Desde: " + this.sFechaRangoInicio + " Hasta: " + this.sFechaRangoFin
      );
    },
  },
};
</script>
 <style lang="scss" scoped>
.no-click {
  opacity: 0.3 !important;
  pointer-events: none !important;
}
</style>